import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { Shield, ArrowRight } from "lucide-react";
import { useEffect } from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_9eb2c609-62e3-467e-b17e-230b32f56602/artifacts/8wo2hyy0_eZamindar%20LoGo.PNG";

export default function LoginPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <img src={LOGO_URL} alt="eZamindar" className="w-20 h-20 mx-auto mb-4 object-contain" />
          <h1 className="font-serif text-3xl tracking-tight text-white">
            e<span className="text-[#D4AF37]">Z</span>amindar
          </h1>
          <p className="text-white/50 text-sm mt-2 font-sans">Property Intelligence Framework</p>
        </div>

        <div className="bg-[#11130F] border border-white/10 rounded-sm p-8">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-5 h-5 text-[#D4AF37]" />
            <h2 className="font-serif text-xl text-white">Secure Access</h2>
          </div>

          <p className="text-white/60 text-sm mb-8 font-sans leading-relaxed">
            Sign in to access your Property Intelligence Dashboard. Your data is encrypted and protected with enterprise-grade security.
          </p>

          <button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="w-full bg-[#D4AF37] text-black font-semibold py-3 px-6 rounded-sm hover:bg-[#F59E0B] transition-colors flex items-center justify-center gap-3"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
              <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Continue with Google
            <ArrowRight className="w-4 h-4" />
          </button>

          <div className="mt-6 pt-6 border-t border-white/10 text-center">
            <p className="text-white/40 text-xs font-sans">
              By signing in, you agree to the eZamindar Terms of Service and Privacy Policy.
            </p>
          </div>
        </div>

        <div className="text-center mt-6">
          <button
            data-testid="back-to-home-btn"
            onClick={() => navigate("/")}
            className="text-white/40 hover:text-[#D4AF37] text-sm transition-colors"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
